import React from 'react';
import type { IProsjektStatistics } from '../services/types';
import { Block, Link, Typography } from '@klp/design';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import { KlpPalette } from '@klp/design/Theme/KlpPalette';
import { KlpFontVariant } from '@klp/design/Theme/KlpFontVariant';
import { tildeltMegLenke } from '@forvalter/frontpage/hooks/useListFilters';
import { ProsjektRoutes } from '../config';
type ProsjektSummaryStatisticsProps = {
    statistics?: IProsjektStatistics;
};

const useStyles = makeStyles(() => ({
    greenText: {
        color: KlpPalette.secondary.main,
    },
    text: {
        paddingTop: '5px',
        paddingLeft: '2px',
        fontSize: KlpFontVariant.small.fontSize,
    },
}));
export const ProsjektSummaryStatistics: React.FC<
    ProsjektSummaryStatisticsProps
> = ({ statistics }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Block marginBottom="bulky">
            <Typography
                klpTypographyVariant="epsilon"
                data-cy="ProsjektSummary__MarkedValue"
            >
                <span className={classes.greenText}>
                    {statistics?.TildeltMeg}{' '}
                </span>
                &nbsp;
                <span className={classes.text}>
                    <Link
                        href={`${ProsjektRoutes.projectSchema()}${tildeltMegLenke}`}
                        translation="prosjekt.assignedToMe"
                    />
                </span>
            </Typography>
            <Typography
                klpTypographyVariant="epsilon"
                data-cy="ProsjektSummary__MarkedValue"
            >
                <span className={classes.greenText}>
                    {statistics?.TilGodkjenning}{' '}
                </span>
                &nbsp;
                <span className={classes.text}>
                    {t('prosjekt.forApproval')}
                </span>
            </Typography>
            <Typography
                klpTypographyVariant="epsilon"
                data-cy="ProsjektSummary__MarkedValue"
            >
                <span className={classes.greenText}>
                    {statistics?.Godkjent}{' '}
                </span>
                &nbsp;
                <span className={classes.text}>{t('prosjekt.approved')}</span>
            </Typography>
            <Typography
                klpTypographyVariant="epsilon"
                data-cy="ProsjektSummary__MarkedValue"
            >
                <span className={classes.greenText}>{statistics?.Avvist} </span>
                &nbsp;
                <span className={classes.text}>{t('prosjekt.declined')}</span>
            </Typography>
        </Block>
    );
};
